import { BrowserRouter, Routes, Route } from "react-router-dom";
import Registration from "./user/regisration"; // pastikan nama file sesuai
import ScanQR from "./admin/scan";
import Dashboard from "./admin/dashboard";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Registration />} />
        <Route path="/scanqr" element={<ScanQR />} />
        <Route path="/pd" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
